
import * as React from 'react';

import InsightsReportsQueriesCollabaryInstagram from './instagram/InsightsReportsQueriesCollabaryInstagram';

import type {
  GeneralProps,
  Query,
  QuerySave,
  Report
} from 'modules/insights/reports/types';

type Props = {
  report: Report,
  isActionEvent: boolean,
  onSaveQuery: (data: QuerySave) => void,
  onUpdateQuery: (query: Query) => void,
  onDuplicateQuery: (query: Query) => void,
  onDeleteQuery: (props: GeneralProps) => void
};

class InsightsReportsQueriesCollabary extends React.PureComponent<Props> {
  renderInstagram(): React.ReactNode {
    const {
      report,
      isActionEvent,
      onSaveQuery,
      onUpdateQuery,
      onDuplicateQuery,
      onDeleteQuery
    } = this.props;

    return (
      <div className="insights-reports-queries-collabary__instagram">
        <InsightsReportsQueriesCollabaryInstagram
          report={report}
          isActionEvent={isActionEvent}
          onSaveQuery={onSaveQuery}
          onUpdateQuery={onUpdateQuery}
          onDuplicateQuery={onDuplicateQuery}
          onDeleteQuery={onDeleteQuery}
        />
      </div>
    );
  }

  render(): React.ReactNode {
    return (
      <div className="insights-reports-queries-collabary">
        {this.renderInstagram()}
      </div>
    );
  }
}

export default InsightsReportsQueriesCollabary;
